export default __webpack_public_path__ + "static/media/ethicalHacking1.68c69f15.jpg";